const dataStore = {

    sliderObject: null,

    collectedAnswers: [],
    multiAnswers : [],

    showConfirmation: false,
    showOptionMenu: false,
    showListOrMap: 0,
    infoWinOpen: false,

    faqOpen: false,
    showShareLink: false,

    addLink: true,

    showWolcomeWindow: true,

    movingPin: null,
    justMovedPin: false,

    limitOnSlideReached: false,

    forceCloseInfoWindow: false,

    heatMapDataPoints: [],

    heatMapDataPointsTimoutDebounce : null,

    itemPaths: [],
    errors: [],
    addopinion: null,
    activeItem: 0,

    showPolygon: true,

    currentOpinion: {
        value_type: "",
        values: [],
        comment: "",
        image: { name: "", file: null }
    },

    addToExistingWindow: false,

    error : false,

    reported: [],
    feedbackOverride: false,
    showReportWindow: false,
    currentToReport: null,

    infoWindowPos: { lat: 10, lng: 10 },
    showHintWindow: true,
    slickNavigation: null,
    showListing: false,
    totalSlideCount: null,
    currentSlide: null,
    currentSlideNumber: null,
    formPopUpReady: false,
    showHeatMap: false,
    project: null,
    showLastPartForm: false,
    deepLink: "",
    showSpinnerLastPart: false,

    currentMapCenter : null,

    currentMapZoom: null,

    toggleInfoBox: false,
    scale: [],
    allowToChange: false,
    selectedFilters: [],
    termsVisable: false,

    activeViewIndex: 0,

    showOnMapPopup: false,

    showOnMapPopupMarker: null,

    viewActive: {
        normal: true,
        heatmap: false,
        listing: false
    },

};

export default dataStore;
